import { message } from 'antd';

type ToastMessageProps = {
  content: string;
  type?: 'info' | 'success' | 'error' | 'warning' | 'loading';
  duration?: number;
};

export const ToastMessage = ({
  content,
  type = 'info',
  duration = 3,
}: ToastMessageProps) => {
  message[type]({
    content,
    style: {
      display: 'flex',
      justifyContent: 'right',
      marginRight: '20px',
      zIndex: 1000,
    },
    duration,
  });
};
